// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/tracking_domain.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateTrackingDomainRequest, CreateTrackingDomainResponse, DeleteTrackingDomainRequest, DeleteTrackingDomainResponse, GetDomainPortRequest, GetDomainPortResponse, GetTrackingDomainRequest, GetTrackingDomainResponse, ListTrackingDomainsRequest, ListTrackingDomainsResponse, SetDefaultTrackingDomainRequest, SetDefaultTrackingDomainResponse, SyncTrackingDomainRequest, SyncTrackingDomainResponse, UpdateTrackingDomainRequest, UpdateTrackingDomainResponse } from "./tracking_domain_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.TrackingDomainService
 */
export const TrackingDomainService = {
  typeName: "tracker.v1.TrackingDomainService",
  methods: {
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.ListTrackingDomains
     */
    listTrackingDomains: {
      name: "ListTrackingDomains",
      I: ListTrackingDomainsRequest,
      O: ListTrackingDomainsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.GetTrackingDomain
     */
    getTrackingDomain: {
      name: "GetTrackingDomain",
      I: GetTrackingDomainRequest,
      O: GetTrackingDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.CreateTrackingDomain
     */
    createTrackingDomain: {
      name: "CreateTrackingDomain",
      I: CreateTrackingDomainRequest,
      O: CreateTrackingDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.UpdateTrackingDomain
     */
    updateTrackingDomain: {
      name: "UpdateTrackingDomain",
      I: UpdateTrackingDomainRequest,
      O: UpdateTrackingDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.DeleteTrackingDomain
     */
    deleteTrackingDomain: {
      name: "DeleteTrackingDomain",
      I: DeleteTrackingDomainRequest,
      O: DeleteTrackingDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.SetDefaultTrackingDomain
     */
    setDefaultTrackingDomain: {
      name: "SetDefaultTrackingDomain",
      I: SetDefaultTrackingDomainRequest,
      O: SetDefaultTrackingDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.TrackingDomainService.SyncTrackingDomain
     */
    syncTrackingDomain: {
      name: "SyncTrackingDomain",
      I: SyncTrackingDomainRequest,
      O: SyncTrackingDomainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetDomainPort: how «Подключить домен» attaches a name for the caller now.
     *
     * @generated from rpc tracker.v1.TrackingDomainService.GetDomainPort
     */
    getDomainPort: {
      name: "GetDomainPort",
      I: GetDomainPortRequest,
      O: GetDomainPortResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

